var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 2.3125H14.25C14.3403 2.31243 14.4302 2.32975 14.5137 2.36426C14.597 2.39876 14.6725 2.44991 14.7363 2.51367L19.9863 7.76367C20.0501 7.82751 20.1012 7.90296 20.1357 7.98633C20.1702 8.06979 20.1876 8.15969 20.1875 8.25V20.25C20.1875 20.6312 20.0362 20.997 19.7666 21.2666C19.497 21.5362 19.1312 21.6875 18.75 21.6875H5.25C4.86875 21.6875 4.50298 21.5362 4.2334 21.2666C3.96381 20.997 3.8125 20.6312 3.8125 20.25V3.75C3.8125 3.36875 3.96381 3.00298 4.2334 2.7334C4.50298 2.46381 4.86875 2.3125 5.25 2.3125ZM5.1875 20.3125H18.8125V8.9375H14.25C14.0677 8.9375 13.8926 8.86526 13.7637 8.73633C13.6347 8.6074 13.5625 8.43234 13.5625 8.25V3.6875H5.1875V20.3125ZM14.9375 7.5625H17.8408L17.7334 7.45605L15.0439 4.7666L14.9375 4.65918V7.5625Z",
    fill: "#0D70DC",
    stroke: "#0D70DC",
    strokeWidth: 0.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1abd6c7f4442cf2851786a548eec17e0.svg";
export { ForwardRef as ReactComponent };